import React, { useState, useEffect } from 'react';
import DarkThemeIcon from "@/components/icons/DarkThemeIcon";
import LightThemeIcon from "@/components/icons/LightThemeIcon";

const ThemeSwitcher = () => {
  const [currentTheme, setCurrentTheme] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    return savedTheme || 'auto';
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(false);
    if (currentTheme === 'auto') {
      const savedTheme = localStorage.getItem('theme');
      if (savedTheme) {
        document.documentElement.setAttribute('data-eo-theme', savedTheme);
      }
    } else {
      document.documentElement.setAttribute('data-eo-theme', currentTheme);
      setIsLoading(true);
      localStorage.setItem('theme', currentTheme);
    }
  }, [currentTheme]);

  const handleThemeChange = () => {
    setCurrentTheme(currentTheme === 'dark' ? 'light' : 'dark');
  };

  return (
    <div
      className="themeSwitch-option"
      data-theme={currentTheme}
      onClick={handleThemeChange}
      style={{ cursor: 'pointer' }}
      aria-label="Switch between light and dark mode"
    >
      {currentTheme === 'light' ? <DarkThemeIcon /> : <LightThemeIcon />}
    </div>
  );
};

export default ThemeSwitcher;